import React from 'react';
import adminApi from '../../api';
import { HyperdbListing } from '../../../hyperdb';

export default HyperdbListing({
  customApi: adminApi,
  collectionName: 'customers',
  namespace: 'customer',
  mountedUrl: '/customers',
  title: 'Customers',
  columns: [
    { attribute: 'name' },
    { attribute: 'client_id' },
    { attribute: 'domain_name' },
    { attribute: 'registration_date' },
    { attribute: 'expiry_date' },
    { label: 'active', value: (o) => o.active ? <i className="fas fa-check" /> : null },
  ],
  useQuickSearch: true,
});



// WEBPACK FOOTER //
// ./src/frontend/admin/customer/containers/Listing.jsx